export class TypeCPVClass {

	public classPrincipale: string;

	public classSupplementaire: string[];

	constructor() { 
		 		this.classPrincipale = '';
		this.classSupplementaire = [];
 
	}
}
